<template>
  <div>
    <el-dialog
      title="发送"
      v-model="editFormVisible"
      :visible.sync="editFormVisible"
    >
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="类型" prop="type">
          <el-input v-model="editForm.type" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="editForm.content" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="学届" prop="Title">
          <el-select
            v-model="value1"
            placeholder="请选择"
            @change="onOptionsyear"
          >
            <el-option
              v-for="item in optionsyear"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级" prop="Title">
          <el-select
            v-model="value2"
            placeholder="请选择"
            @change="onOptionsyear"
          >
            <el-option
              v-for="item in optionsyear2"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click.native="editSubmit(2,0)"
            >发送全年级</el-button
          >
          <br />
        </el-form-item>
        <el-form-item label="班级" prop="Title">
          <el-select
            v-model="value3"
            placeholder="请选择"
            @change="onClickClass"
          >
            <el-option
              v-for="item in optionsyear3"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click.native="editSubmit(3,0)"
            >发送班级</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit(1,0)"
          >发送全校</el-button
        >
      </div>
      <el-table
        :data="users"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column type="index" width="80"> </el-table-column>
        <el-table-column prop="Name" label="姓名" width="" sortable>
        </el-table-column>
        <el-table-column prop="SexName" label="性别" width="" sortable>
        </el-table-column>
              <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="editSubmit(4,scope.row.Id)"
            >发送消息</el-button
          >
        </template>
      </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
      <!-- 2 -->
    </el-dialog>
  </div>
</template>

<script>
import {
  GetYearsInfo,
  GetGradeInfo,
  GetClassInfo,
  SchoolSendMsg,
  SendmsgGetStudentInfoByPage,
} from "../../api/api";
export default {
  data() {
    return {
      page: 1,
      pagesize: 10,
      total: 0,
      users: [],
      listLoading: false,
      editFormVisible: true,
      editForm: {},
      activeName: "first",
      orgOptions: {},
      pieOrgOptions: {},
      piesOrgOptions: {},
      twoOrgOptions: {},
      threeOptions: {},

      optionsyear: [],
      optionsyear2: [],
      optionsyear3: [],
      value1: "",
      value2: "",
      value3: "",
      courseId: 0,
      classids: [],
    };
  },
  created() {
    this.courseId = this.$route.query.Id;
    this.GetYearsInfo();
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.onClickClass();
    },
    editSubmit(num,sid) {
      if (this.editForm.type == "" || this.editForm.content == ""||this.editForm.type == null || this.editForm.content == null) {
        this.$message({
          message: "请输入类型和内容",
          type: "error",
        });
        return false;
      }
      let data = {
        type: this.editForm.type,
        content: this.editForm.content,
      };
      if (num == 2) {
        if (this.value1 == "" || this.value2 == ""||this.value1 == null || this.value2 == null) {
          this.$message({
            message: "请选择学届和年级",
            type: "error",
          });
          return false;
        }
        data.yearId = this.value1;
        data.gradeId = this.value2;
      } else if (num == 3) {
        if (this.value1 == "" || this.value2 == "" || this.value3 == "") {
          this.$message({
            message: "请选择学届和年级和班级",
            type: "error",
          });
          return false;
        }
        data.yearId = this.value1;
        data.gradeId = this.value2;
        data.classId = this.value3;
      } else if (num == 4) {
        data.studentId = sid;
      }
      SchoolSendMsg(data).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message:  res.data.msg,
            type: "error",
          });
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onClickClass() {
      let data = {
        PageIndex: this.page,
        PageSize: this.pagesize,
        StudyYearId: this.value1,
        GradeId: this.value2,
        ClassId: this.value3,
      };
      SendmsgGetStudentInfoByPage(data).then((res) => {
        console.log(res);
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
      });
    },
    onOptionsyear() {
      if (this.value1 != "" && this.value2 != "") {
        let params = {
          studyYearId: this.value1,
          gradeId: this.value2,
        };
        GetClassInfo(params).then((res) => {
          // if (res.data.response.length > 0) {
          //   this.value3 = res.data.response[0].Id;
          //   this.onClickClass(this.categoryId);
          // }
          this.optionsyear3 = res.data.response;
        });
      } else {
        console.log(3333);
      }
    },
    //获取用户列表
    GetYearsInfo() {
      GetYearsInfo().then((res) => {
        // if (res.data.response.length > 0) {
        //   this.value1 = res.data.response[0].Id;
        // }
        this.optionsyear = res.data.response;
      });
      GetGradeInfo().then((res) => {
        // if (res.data.response.length > 0) {
        //   this.value2 = res.data.response[0].Id;
        //   this.onOptionsyear();
        // }
        this.optionsyear2 = res.data.response;
      });
      this.onOptionsyear();
    },
  },
  mounted() {},
};
</script>

<style scoped>
.class_header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sex_header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.echarts_demo {
  width: 800px;
}
.el-select {
  margin: 10px;
}
</style>